import { useQuery, UseQueryOptions } from 'react-query'

import { AxiosError } from 'axios'
import ApiCall from 'services/ApiCall'

import useUrlQuery, { UseUrlQueryOptions } from 'helpers/QueryUrl/useUrlQuery'

export interface GalleryGetSequences {
  id: string
  name: string
  path: string
  type: 'image' | 'video'
  category: string
  createdAt: string
  updatedAt: string
  deletedAt: null | null
}

type useAllResult = {
  data: any
  result: GalleryGetSequences[]
  total: number
}

type TQueryFnData = useAllResult
type TError = AxiosError

function useGetAllGallery(
  page: number,
  pageSize: number,
  filter?: any,
  type?: any,
  urlOptions?: UseUrlQueryOptions,
  options?: UseQueryOptions<TQueryFnData, TError>,
) {
  const urlQuery = useUrlQuery(urlOptions)
  const queryKey = ['getAllGallery', page, pageSize, filter, type]
  const query = useQuery<TQueryFnData, TError>(
    queryKey,
    () =>
      ApiCall.Gallery.get(page, pageSize, filter, type).then((res) => {
        return res.data
      }),
    {
      ...options,
      keepPreviousData: true,
    },
  )

  return {
    ...query,
    data: query?.data?.data,
    length: query?.data?.total,
    helpers: urlQuery,
  }
}

export default useGetAllGallery
